import * as React from "react";

import { LoginFormUi } from "../../Common";

import { useReactJoinInitialState } from "../providers";

export const PageLogin: React.FunctionComponent = () => {
  return (
    <section className="page page-login">
      <LoginFormUi useInitialState={useReactJoinInitialState} />
    </section>
  );
};
